import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle, ArrowRight, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Success = () => {
  const [searchParams] = useSearchParams();
  const { user, checkSubscription } = useAuth();
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    const verifyPayment = async () => {
      if (user) {
        await checkSubscription(user.id);
      }
      setLoading(false);
    };

    // Small delay to ensure webhook has processed
    const timer = setTimeout(verifyPayment, 2000);
    return () => clearTimeout(timer);
  }, [user, checkSubscription]);

  return (
    <div className="min-h-screen bg-dark-950 flex items-center justify-center px-4">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/3 -right-40 w-80 h-80 bg-green-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 -left-40 w-80 h-80 bg-primary-500/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-lg">
        <div className="glass rounded-2xl p-8 text-center">
          {loading ? (
            <div className="py-8">
              <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary-500 mx-auto mb-6"></div>
              <h2 className="text-xl font-semibold text-white mb-2">
                Zpracovávám platbu...
              </h2>
              <p className="text-dark-400">
                Moment prosím, ověřujeme vaši platbu.
              </p>
            </div>
          ) : (
            <>
              <div className="relative">
                <div className="w-20 h-20 mx-auto rounded-full bg-green-500/20 flex items-center justify-center mb-6">
                  <CheckCircle size={40} className="text-green-400" />
                </div>
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-2">
                  <Sparkles size={24} className="text-amber-400 animate-pulse" />
                </div>
              </div>

              <h1 className="text-3xl font-bold text-white mb-4">
                Platba úspěšná!
              </h1>

              <p className="text-dark-400 mb-8">
                Děkujeme za vaši platbu. Vaše předplatné bylo aktivováno a máte
                nyní plný přístup ke všem funkcím Synapso.
              </p>

              <div className="space-y-4">
                <Link
                  to="/dashboard"
                  className="w-full inline-flex items-center justify-center space-x-2 px-6 py-3 rounded-xl gradient-bg text-white font-semibold btn-hover"
                >
                  <span>Přejít na dashboard</span>
                  <ArrowRight size={20} />
                </Link>

                <p className="text-dark-500 text-sm">
                  Potvrzení o platbě vám bylo zasláno na email.
                </p>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Success;
